<template lang="html">
  <div class="carousel-wrapper">
    <!-- <img src="@/assets/images/defaultCarousel.png" alt=""> -->
    <carousel
      v-if="false"
      :perPage="1"
      :loop="false"
      :paginationEnabled="true"
      :navigateTo="navigateTo"
    >
      <slide v-for="(image, index) in images" :key="index">
        <img :src="image" alt="carousel image" />
      </slide>
      <slide>
        <div class="video-image-wrapper">
          <img
            class="video-image"
            src="@/assets/images/video.png"
            alt=""
            v-show="!showVideo"
          />
          <div class="text-wrapper">
            <h3>{{ $t("main.videoHeader") }}</h3>
            <p>{{ $t("main.videoText") }}</p>
            <div @click="$emit('changeShowVideo', true)" class="button">
              {{ $t("main.videoButton") }}
            </div>
          </div>
        </div>
      </slide>
    </carousel>

    <carousel
      v-else
      :perPage="1"
      :loop="true"
      :paginationEnabled="true"
      :navigateTo="navigateTo"
    >
      <slide>
        <a
          class=" video-image-wrapper go-to-site"
          href="https://joveilicaresidence.rs/"
          target="_blank"
        >
          <img src="../../assets/images/joveilica.png" alt="carousel image" />
          <!-- <div class="text-wrapper" style="align-self: center;">
            <div class="button">{{ $t("main.videoButton") }}</div>
          </div> -->
        </a>
      </slide>

      <slide>
        <a
          class="video-image-wrapper go-to-site"
          href="https://www.upfront-enablers.com/"
          target="_blank"
        >
          <img src="../../assets/images/carousel.jpeg" alt="carousel image" />
          <div class="text-wrapper">
            <div class="button">
              {{ $t("main.videoButton") }}
            </div>
          </div>
        </a>
      </slide>
      <slide>
        <div class="video-image-wrapper">
          <img
            class="video-image"
            src="@/assets/images/video.png"
            alt=""
            v-show="!showVideo"
          />
          <div class="text-wrapper">
            <h3>{{ $t("main.videoHeader") }}</h3>
            <p>{{ $t("main.videoText") }}</p>
            <div @click="$emit('changeShowVideo', true)" class="button">
              {{ $t("main.videoButton") }}
            </div>
          </div>
        </div>
      </slide>
      <!-- <slide v-if="false">
        <div class="video-image-wrapper">
          <video  ref="videoRef1" id="video-container" width="100%" class="imgExp" autoplay  loop muted playsinline controls>
               <source ref="sourceRef2" src="https://081k122.mars-t.mars-hosting.com/video/demo.mp4"  type="video/mp4"/>
          </video>
        </div>
      </slide> -->
    </carousel>
    <div class="navigation">
      <div @click="changeSlide('left')" class="left">
        <img
          src="@/assets/icons/carouselArrowRight.png"
          alt="carousel right arrow"
        />
      </div>
      <div @click="changeSlide('right')" class="right">
        <img
          src="@/assets/icons/carouselArrowRight.png"
          alt="carousel right arrow"
        />
      </div>
    </div>
    <!-- <div class="pagination">
      <div
        :class="{ active: index === navigateTo}"
        class="pagination-number"
        v-for="(image, index) in images"
        :key="index"
        @click="navigateTo = index, setUpInterval()"
      >
        {{formatNumber(index + 1)}}
      </div>
    </div> -->
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  name: "carouselWrapper",
  props: {
    images: {
      required: true,
      type: Array,
      default: () => {
        return ["@/assets/images/defaultCarousel.png"];
      }
    },
    showVideo: {
      type: Boolean
    }
  },
  data() {
    return {
      navigateTo: 0,
      interval: null,
      videoSrc: "https://eberza.e-lite.info/video/demo.mp4"
    };
  },
  components: {
    Carousel,
    Slide
  },
  mounted() {
    this.setUpInterval();
  },
  methods: {
    getVideoSrc() {
      console.log(baseURL.replace("api", ""));
      if (this.$route.params.lang === "sr") {
        this.videoSrc = baseURL.replace("api", "") + "video/demo.mp4";
      } else {
        this.videoSrc = baseURL.replace("api", "") + "video/demo-english.mp4";
      }
    },
    setUpInterval() {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.navigate();
      }, 10 * 1000);
    },
    navigate() {
      // if (this.navigateTo + 1 === this.images.length + 1) {
      //   this.navigateTo = 0
      // } else {
      //   this.navigateTo += 1
      // }
      if (this.navigateTo + 1 === 3) {
        this.navigateTo = 0;
      } else {
        this.navigateTo += 1;
      }
    },
    changeSlide(direction) {
      // adding +1 because of the video slider
      // if (direction === 'left') {
      //   if (this.navigateTo - 1 !== -1) {
      //     this.navigateTo -= 1
      //   } else {
      //     this.navigateTo = this.images.length
      //   }
      // } else {
      //   if (this.navigateTo + 1 < this.images.length + 1) {
      //     this.navigateTo += 1
      //   } else {
      //     this.navigateTo = 0
      //   }
      // }

      if (direction === "left") {
        if (this.navigateTo - 1 !== -1) {
          this.navigateTo -= 1;
        } else {
          this.navigateTo = 1;
        }
      } else {
        if (this.navigateTo + 1 < 3) {
          this.navigateTo += 1;
        } else {
          this.navigateTo = 0;
        }
      }
      this.setUpInterval();
    },
    formatNumber(num) {
      if (num.toString().length === 1) {
        return "0" + num;
      }
      return num;
    },
    deleted() {
      clearInterval(this.interval);
    }
  },
  watch: {
    showVideo: {
      handler: function() {
        let element = document.querySelector("#video");
        if (this.showVideo) {
          element.requestFullscreen();
          element.play();
        } else {
          element.pause();
        }
      }
    }
  }
};
</script>
<style lang="scss">
.video-image-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 290px;
  background-color: #0c355e;
  overflow: hidden !important;
  box-sizing: border-box;
  height: 100% !important;

  img {
    filter: brightness(0.65);
    height: 100% !important;
  }

  .text-wrapper {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
      margin-top: 0px;
      margin-bottom: 0px;
      font-family: Open Sans;
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 35px;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: #ffffff;
    }
    .button {
      width: 127px;
      height: 41px;
      background: #ffffff;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      line-height: 41px;
      letter-spacing: 0.04em;
      color: #8e3e4c;
      text-transform: uppercase;
      cursor: pointer;
      margin-top: 25px;
      transition-duration: 0.3s;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 17px;
      line-height: 175.9%;
      text-align: center;
      letter-spacing: 0.04em;
      color: #ffffff;
      max-width: 60%;
    }
  }
}
.go-to-site {
  display: flex;
  justify-content: center;
  cursor: pointer;
  max-height: 290px;
  background-color: #ffffff;
  img {
    filter: none;
  }
  .text-wrapper {
    align-self: end;
    margin-bottom: 13px;
    .button {
      text-decoration: none;
    }
  }
}

.top-section-wrapper {
  .carousel-wrapper {
    .VueCarousel-inner {
      max-height: 600px;
    }
    .VueCarousel-slide {
      // height: 320px;
    }
    .VueCarousel-pagination {
      bottom: 0px !important;

      .VueCarousel-dot {
        background: #ffffff;
        opacity: 0.6;
        padding: 0px !important;
        margin: 5px !important;
      }
      .VueCarousel-dot.VueCarousel-dot--active {
        background: #ffffff !important;
        opacity: 1;
        padding: 2px !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.carousel-wrapper {
  flex-grow: 1;
  position: relative;

  img {
    width: 100%;
    height: auto;
  }
  .navigation {
    position: absolute;
    top: 33%;
    height: 33%;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .left,
    .right {
      padding: 30px;
      height: 32px;
      width: 17px;

      img {
        transition-duration: 0.2s;
        cursor: pointer;
      }
    }
    .left img {
      transform: rotate(180deg);
    }
    .left:hover img,
    .right:hover img {
      transform: scale(1.1);
    }
    .left:hover img {
      transform: rotate(180deg) scale(1.1);
    }
  }
  .pagination {
    position: absolute;
    top: 30px;
    left: 30px;
    display: flex;
    flex-direction: row;

    .pagination-number {
      margin-right: 5px;
      color: #969696;
      font-size: 15px;
      cursor: pointer;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      transition-duration: 0.2s;
      width: 30px;
      line-height: 30px;
    }
    .pagination-number.active {
      color: #969696;
      font-weight: bold;
      font-size: 30px;
      cursor: pointer;
    }
  }
}
@media only screen and (max-width: 1000px) {
  .pagination {
    top: 10px !important;
    left: 10px !important;
  }
}
@media only screen and (max-width: 768px) {
  .carousel-wrapper {
    // min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    .VueCarousel {
      // position: absolute;
      // height: 300px;
      width: 800px;
    }

    .video-image-wrapper {
      .text-wrapper {
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;

        h3 {
          margin-top: 0px;
          margin-bottom: 0px;
          font-family: Open Sans;
          font-style: normal;
          font-weight: bold;
          font-size: 18px;
          line-height: 15px;
          letter-spacing: 0.02em;
          text-transform: uppercase;
          color: #ffffff;
        }
        .button {
          width: 127px;
          height: 41px;
          background: #ffffff;
          font-style: normal;
          font-weight: bold;
          font-size: 12px;
          line-height: 41px;
          letter-spacing: 0.04em;
          color: #8e3e4c;
          text-transform: uppercase;
          cursor: pointer;
          margin-top: 15px;
          transition-duration: 0.3s;
        }
        p {
          font-style: normal;
          font-weight: normal;
          font-size: 13px;
          line-height: 135.9%;
          text-align: center;
          letter-spacing: 0.02em;
          color: #ffffff;
          max-width: 60%;
        }
      }
    }
  }
}
</style>
